import { render, staticRenderFns } from "./roommate-modal-form.vue?vue&type=template&id=1235cc26"
import script from "./roommate-modal-form.vue?vue&type=script&lang=js"
export * from "./roommate-modal-form.vue?vue&type=script&lang=js"
import style0 from "./roommate-modal-form.vue?vue&type=style&index=0&id=1235cc26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports